import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import type { TranslationFunction } from '@/app/components/translations/Translation';
import type { ControlProps } from '../../../Form';
import { getMultilistboxValue } from '../utils';
import getListboxContainer from './getListboxContainer';
import FilterContainer from '../FilterContainer';
import type { CommonProps } from './CommonProps';

type GetWaterWavesField = {
  searchParams: SearchParams;
  commonProps: CommonProps;
  t: TranslationFunction;
};

export const getWaterWavesOptions = ({ t, isWaiting }: { t: TranslationFunction; isWaiting?: boolean }) => [
  { value: 1, label: t('vacation.oss.filters.waterwaves.full_calm'), disabled: isWaiting },
  { value: 2, label: t('vacation.oss.filters.waterwaves.weak'), disabled: isWaiting },
  { value: 3, label: t('vacation.oss.filters.waterwaves.moderate'), disabled: isWaiting },
  { value: 4, label: t('vacation.oss.filters.waterwaves.high_waves'), disabled: isWaiting },
];

const getWaterWavesField = ({ t, searchParams, commonProps }: GetWaterWavesField): ControlProps => {
  const { isWaiting } = commonProps;

  return getListboxContainer({
    fieldName: URLParameters.WATER_WAVES,
    containerName: FilterContainer.WaterwavesContainer,
    containerTitle: t('vacation.oss.filters.waterwaves.title'),
    options: getWaterWavesOptions({ t, isWaiting }),
    value: getMultilistboxValue(searchParams[URLParameters.WATER_WAVES], true),
    fieldClassName: '',
    ...commonProps,
  });
};

export default getWaterWavesField;
